import React, { useState, useEffect, useRef } from "react";
import {
  Grid,
  TextField,
  Box,
  Button,
  Typography,
  Modal,
  IconButton,
  Paper,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import axios from "axios";
import Swal from "sweetalert2";
import moment from "moment";
const ConsentForm = (props) => {
  const token = localStorage.getItem("Token");
  const auth = `Bearer ${token}`;
  const headers = {
    Authorization: auth,
  };

  const [formData, setFormData] = useState({
    signature: "",
    date: "",
    printName: "",
  });
  const [SignatureDate, setSignatureDate] = useState(
    moment().format("YYYY-MM-DD"),
  );
  const [Signature, setSignature] = useState("");
  const [PrintName, setPrintName] = useState("");
  const FormId = props.FormId;
  useEffect(() => {
    if (FormId) {
      axios
        .get(
          `${process.env.REACT_APP_API_URL}/PatientForms/GetFormInformedConsentId?id=${FormId}`,
          { headers },
        )
        .then((response) => {
          // setSignatureDate(moment(response.signatureDate).format("MM-DD-YYYY"));
          setSignatureDate(
            response.signatureDate
              ? moment(response.signatureDate).format("YYYY-MM-DD")
              : "",
          );
          setSignature(response.patientSignature);
          setPrintName(response.patientName);
          // setFormData((prev) => ({
          //     ...prev,
          //     signature: response.patientSignature,
          //     printName: response.patientName,
          //     date: response.signatureDate
          //       ? moment(response.signatureDate).format("MM-DD-YYYY")
          //       : "",
          //   }));
        })
        .catch((error) => {});
    }
  }, [FormId]);

  const handleSubmit = async () => {
    const postData = {
      id: props.FormId,
      patientName: props.PatientName,
      patientId: props.PatientId,
      patientSignature: Signature,
      signatureDate: SignatureDate,
    };

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/PatientForms/AddFormInformedConsent`,
        postData,
        { headers },
      );

      Swal.fire({
        icon: "success",
        title: "Form Added!",
        html: `<p>Informed Consent Form has been saved successfully.</p>`,
        timer: 2000, // 2 seconds
        showConfirmButton: false,
        timerProgressBar: true,
        willOpen: () => {
          const swalPopup = document.querySelector(".swal2-container");
          if (swalPopup) swalPopup.style.zIndex = 2200;
        },
      });
      if (props.onFormSubmit) {
        props.onFormSubmit(response); // send full response or response.data.id
      }

      props.handleClose();
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Failed!",
        html: `<p>${
          error.response?.data?.message ||
          "Something went wrong. Please try again."
        }</p>`,
        confirmButtonColor: "#F44336",
        willOpen: () => {
          const swalPopup = document.querySelector(".swal2-container");
          if (swalPopup) swalPopup.style.zIndex = 2200;
        },
      });
    }
  };

  const [progressNoteDialogOpen, setProgressNoteDialogOpen] = useState(false);
  const [progressNoteContent, setProgressNoteContent] = useState("");
  const formRef = useRef(null);
  const [editorHTML, setEditorHTML] = useState("");
  const replaceInputsWithText = (container) => {
    if (!container) return;

    // Replace radios with ☑/☐
    const radios = container.querySelectorAll('input[type="radio"]');
    radios.forEach((radio) => {
      const checked = radio.checked ? "☑" : "☐";
      const span = document.createElement("span");
      span.innerHTML = `${checked}`;
      span.style.marginRight = "12px";
      span.style.display = "inline-block";
      span.style.lineHeight = "1.5"; // gives extra height
      radio.parentNode.replaceChild(span, radio);
    });

    // Replace checkboxes with ☑/☐
    const checkboxes = container.querySelectorAll('input[type="checkbox"]');
    checkboxes.forEach((checkbox) => {
      const checked = checkbox.checked ? "☑" : "☐";
      const span = document.createElement("span");
      span.innerHTML = `${checked}`;
      span.style.marginRight = "12px";
      span.style.display = "inline-block";
      span.style.lineHeight = "1.5"; // gives extra height
      checkbox.parentNode.replaceChild(span, checkbox);
    });

    // Replace all text/date/number inputs with bold text
    const textInputs = container.querySelectorAll(
      'input:not([type="radio"]):not([type="checkbox"])',
    );
    textInputs.forEach((input) => {
      const value = input.value || "-";
      const span = document.createElement("span");
      span.innerText = value;
      span.style.fontWeight = "bold";
      span.style.display = "inline-block";
      span.style.padding = "6px 8px"; // adds height/padding
      span.style.minWidth = "120px"; // optional: ensures spacing
      span.style.backgroundColor = "#f0f0f0"; // optional subtle background
      span.style.borderRadius = "4px";
      input.parentNode.replaceChild(span, input);
    });
  };

  const convertToProgressNote = (formData) => {
    if (!formRef.current) return;

    const formClone = formRef.current.cloneNode(true);
    replaceInputsWithText(formClone);

    const html = `
      <div
        style="
          font-family: Calibri, Segoe UI, sans-serif;
          color: #000;
          width: 100%;
          max-width: 100%;
          background: #ffffff;
          border: 1.5px solid #cfd8dc;
          border-radius: 10px;
          box-shadow: 0 4px 14px rgba(0,0,0,0.08);
          box-sizing: border-box;
          overflow-x: auto;
          padding: 10px;
        "
      >
        <div
          style="
            width: 100%;
            box-sizing: border-box;
            padding: 0;
            margin: 0;
          "
        >
          ${formClone.innerHTML}
        </div>
      </div>
    `;

    setEditorHTML(html);
    setProgressNoteDialogOpen(true);
  };

  const onSubmitProgresNote = (data) => {
    const today = new Date().toISOString().split("T")[0];
    const postData = {
      patientId: props.PatientId,
      patientNoteId: 0,
      noteText: editorHTML,
      signedDate: "",
      visitDate: today,
    };

    axios
      .post(
        `${process.env.REACT_APP_API_URL}/PatientNote/AddPatientNote`,
        postData,
        { headers },
      )
      .then((response) => {
        setProgressNoteDialogOpen(false);
        props.handleClose();
        Swal.fire({
          icon: "success",
          timer: 1000,
          showConfirmButton: false,
          title: "Note saved successfully.",
          willOpen: () => {
            const container = document.querySelector(".swal2-container");
            if (container) container.style.zIndex = "1800";
          },
        });
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: `Error ${error.message}`,
          timer: 1000,
          willOpen: () => {
            const container = document.querySelector(".swal2-container");
            if (container) container.style.zIndex = "1800";
          },
        });
      });
  };

  return (
    <>
      <Modal
        open={progressNoteDialogOpen}
        onClose={() => setProgressNoteDialogOpen(false)}
        aria-labelledby="progress-note-modal"
        sx={{
          zIndex: 1820,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          p: 2,
        }}
      >
        <Paper
          elevation={24}
          sx={{
            width: "98%",
            maxWidth: 1020,
            maxHeight: "95vh",
            display: "flex",
            flexDirection: "column",
            borderRadius: 3,
            overflow: "hidden",
          }}
        >
          {/* Header */}
          <Box
            sx={{
              background: "linear-gradient(135deg, #2c5aa0 0%, #1976d2 100%)",
              color: "white",
              p: 1.5,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Box>
              <Typography
                variant="h5"
                fontWeight="bold"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  color: "#fff",
                }}
              >
                Progress Note
              </Typography>
            </Box>
            <IconButton
              onClick={() => setProgressNoteDialogOpen(false)}
              sx={{ color: "white" }}
            >
              <CloseIcon />
            </IconButton>
          </Box>

          {/* Toolbar */}
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              gap: 1,
              p: 1,
              backgroundColor: "#f9f9f9",
              borderBottom: "1px solid #ddd",
            }}
          >
            {[
              { label: "B", command: "bold", style: { fontWeight: "bold" } },
              { label: "I", command: "italic", style: { fontStyle: "italic" } },
              {
                label: "U",
                command: "underline",
                style: { textDecoration: "underline" },
              },
              {
                label: "S",
                command: "strikeThrough",
                style: { textDecoration: "line-through" },
              },
              { label: "Sub", command: "subscript" },
              { label: "Sup", command: "superscript" },
              { label: "• List", command: "insertUnorderedList" },
              { label: "1. List", command: "insertOrderedList" },
              { label: "Left", command: "justifyLeft" },
              { label: "Center", command: "justifyCenter" },
              { label: "Right", command: "justifyRight" },
              { label: "Justify", command: "justifyFull" },
              { label: "H1", command: "formatBlock", value: "h1" },
              { label: "H2", command: "formatBlock", value: "h2" },
              { label: "Quote", command: "formatBlock", value: "blockquote" },
              { label: "Code", command: "formatBlock", value: "pre" },
              { label: "Link", command: "createLink", prompt: true },
              { label: "Text Color", command: "foreColor", color: "#000000" },
              { label: "BG Color", command: "hiliteColor", color: "#FFFF00" },
            ].map((btn) => (
              <Button
                key={btn.label}
                size="small"
                onMouseDown={(e) => {
                  e.preventDefault(); // prevent losing focus
                  if (btn.prompt) {
                    const url = prompt("Enter URL");
                    if (url) document.execCommand(btn.command, false, url);
                  } else if (btn.color) {
                    document.execCommand(btn.command, false, btn.color);
                  } else if (btn.value) {
                    document.execCommand(btn.command, false, btn.value);
                  } else {
                    document.execCommand(btn.command, false, null);
                  }
                }}
                sx={{
                  minWidth: 35,
                  fontWeight: "bold",
                  textTransform: "none",
                  ...btn.style,
                  border: "1px solid #ddd",
                  borderRadius: 2,
                  backgroundColor: "#fff",
                  "&:hover": {
                    backgroundColor: "#e0e0e0",
                  },
                }}
              >
                {btn.label}
              </Button>
            ))}
          </Box>

          {/* Editable content */}
          <Box
            sx={{
              overflowY: "auto",
              backgroundColor: "#fdfdfd",
            }}
          >
            <div
              contentEditable
              suppressContentEditableWarning
              style={{
                minHeight: "75vh",
                border: "1px solid #ccc",
                borderRadius: 4,
                padding: "16px",
                fontFamily: "'Calibri', 'Segoe UI', sans-serif",
                fontSize: 14,
                backgroundColor: "#fff",
                overflowY: "auto",
              }}
              dangerouslySetInnerHTML={{ __html: editorHTML }}
            />
          </Box>

          <Grid
            container
            spacing={1}
            justifyContent="flex-end"
            sx={{
              bgcolor: "#f5f5f5",
              p: 1.5,
              borderTop: 1,
              borderColor: "divider",
              display: "flex",
            }}
          >
            <Grid item>
              <Button
                type="submit"
                variant="contained"
                onClick={onSubmitProgresNote}
                sx={{
                  minWidth: 200,
                  height: 40,
                  borderColor: "#4CAF50",
                  backgroundColor: "#4CAF50",
                  color: "#fff",
                  "&:hover": {
                    backgroundColor: "#4CAF50",
                    color: "white",
                    borderColor: "#4CAF50",
                  },
                }}
              >
                Save Progress Note
              </Button>
            </Grid>
            <Grid item>
              <Button
                variant="contained"
                color="primary"
                onClick={() => setProgressNoteDialogOpen(false)}
              >
                Close
              </Button>
            </Grid>
          </Grid>
        </Paper>
      </Modal>
      <Grid
        container
        columnSpacing={1}
        style={{ color: "black", marginTop: "20px" }}
      >
        <Grid container ref={formRef}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Typography
                variant="h4"
                align="center"
                fontWeight="bold"
                color="primary"
                gutterBottom
              >
                INFORMED CONSENT
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            spacing={3}
            sx={{ m: 2, p: 2, backgroundColor: "#e8f4fd", borderRadius: 2 }}
          >
            <Grid item xs={12} style={{ marginTop: "10px" }}>
              <h3 style={{ fontWeight: "bold" }}>
                Informed Consent for the Treatment of Sleep-Related Breathing
                Disorders
              </h3>
            </Grid>

            <Grid item xs={12} style={{ marginTop: "20px" }}>
              <h6>
                You have been diagnosed by your physician as requiring treatment
                for a sleep-related breathing disorder, such as snoring and/or
                obstructive sleep apnea (OSA). OSA may pose serious health risks
                since it disrupts normal sleep patterns and can reduce normal
                blood oxygen levels. This condition can increase a person’s risk
                for excessive daytime sleepiness, driving and work-related
                accidents, high blood pressure, heart disease, stroke, diabetes,
                obesity, memory and learning problems, and depression.
              </h6>
            </Grid>
          </Grid>
          <Grid
            container
            spacing={3}
            sx={{ m: 2, p: 2, backgroundColor: "#e8f4fd", borderRadius: 2 }}
          >
            <Grid item xs={11} style={{ marginTop: "20px" }}>
              <h5 style={{ fontWeight: "bold" }}>
                What is Oral Appliance Therapy?
              </h5>
            </Grid>

            <Grid item xs={11} style={{ marginTop: "20px" }}>
              <h6>
                Oral appliance therapy for snoring and/or OSA attempts to assist
                breathing by keeping the tongue and jaw in a forward position
                during sleeping hours. OAT has effectively treated many
                patients. However, there are no guarantees that it will be
                effective for you. Every patient’s case is different and there
                are many factors that influence the upper airway during sleep.
                It is important to recognize that even when the therapy is
                effective, there may be a period of time before the appliance
                functions maximally.During this time, you may still experience
                symptoms related to your sleep-related breathing disorder.
                <br />
                <br />A post-adjustment polysomnogram (sleep study) is necessary
                to objectively assure effective treatment. This must be obtained
                from your physician.
              </h6>
            </Grid>
          </Grid>

          <Grid
            container
            spacing={3}
            sx={{ m: 2, p: 2, backgroundColor: "#e8f4fd", borderRadius: 2 }}
          >
            <Grid item xs={11} style={{ marginTop: "25px" }}>
              <h5 style={{ fontWeight: "bold" }}>
                Side-Effects and Complications of Oral Appliance Therapy
              </h5>
            </Grid>

            <Grid item xs={11} style={{ marginTop: "10px" }}>
              <h6>
                Published studies show that short-term side effects of oral
                appliance therapy may include excessive salivation, difficulty
                swallowing (with the appliance in place), sore jaws or teeth,
                jaw joint pain, dry mouth, gum pain, loosening of teeth, and
                short-term bite changes. There are also reports of dislodgement
                of ill-fitting dental restorations. Most of these side effects
                are minor and resolve quickly on their own or with minor
                adjustments of the appliance.
                <br />
                <br />
                Long-term complications include bite changes that may be
                permanent resulting from tooth movement or jaw joint
                repositioning. These complications may or may not be fully
                reversible once oral appliance therapy is discontinued. If not
                reversible, restorative treatment or orthodontic intervention
                may be required for which you will be responsible.
                <br />
                <br />
                Follow-up visits with the provider of your oral appliance are
                mandatory to ensure proper fit and healthy condition. If unusual
                symptoms or discomfort occur that fall outside the scope of this
                consent, or if pain medication is required to control
                discomfort, it is recommended that you cease using the appliance
                until you are evaluated further. As this office cannot ensure
                the success of any type of therapy and cannot guarantee that any
                patient will comply with the treatment for sleep apnea, I hereby
                waive any rights that I, my heirs, and my assigns might have to
                seek legal redress for any damage, physical or monetary, that I
                might sustain as a result of my treatment for sleep apnea or any
                failure on my part to comply with treatment.
              </h6>
            </Grid>
          </Grid>

          <Grid
            container
            spacing={3}
            sx={{ m: 2, p: 2, backgroundColor: "#e8f4fd", borderRadius: 2 }}
          >
            <Grid item xs={11} style={{ marginTop: "30px" }}>
              <h5 style={{ fontWeight: "bold" }}>
                Alternative Treatments for Sleep-Related Breathing Disorders
              </h5>
            </Grid>

            <Grid item xs={11} style={{ marginTop: "20px" }}>
              <h6>
                Other accepted treatments for sleep-related breathing disorders
                include behavioral modification, Continuous Positive Airway
                Pressure (CPAP) and various surgeries. It is your decision to
                choose oral appliance therapy to treat your sleep-related
                breathing disorder and you are aware that it may not be
                completely effective for you. It is your responsibility to
                report the occurrence of side effects and to address any
                questions to this provider’s office. Failure to treat
                sleep-related breathing disorders may increase the likelihood of
                significant medical complications.
                <br />
                <br />
                If you understand the explanation of the proposed treatment, and
                have asked this provider any questions you may have about this
                form of treatment, please sign and date this form below. You
                will receive a copy.
              </h6>
            </Grid>
          </Grid>
          <Grid
            container
            spacing={3}
            sx={{ m: 2, p: 2, backgroundColor: "#e8f4fd", borderRadius: 2 }}
          >
            <Grid item xs={2} style={{ marginTop: "30px" }}>
              <h6>Signature:</h6>
            </Grid>
            <Grid item xs={4} style={{ marginTop: "20px" }}>
              <TextField
                size="small"
                variant="standard"
                name="signature"
                value={Signature}
                onChange={(e) => setSignature(e.target.value)}
                fullWidth
              />
            </Grid>

            <Grid item xs={2} style={{ marginTop: "30px" }}>
              <h6>Date:</h6>
            </Grid>
            <Grid item xs={4} style={{ marginTop: "20px" }}>
              <TextField
                type="date"
                size="small"
                variant="standard"
                value={SignatureDate}
                onChange={(e) => setSignatureDate(e.target.value)}
                fullWidth
              />
            </Grid>

            <Grid item xs={3} style={{ marginTop: "30px" }}>
              <h6>Print Name:</h6>
            </Grid>
            <Grid item xs={9} style={{ marginTop: "20px" }}>
              <TextField
                size="small"
                variant="standard"
                name="printName"
                value={PrintName || props.PatientName}
                onChange={(e) => setPrintName(e.target.value)}
                fullWidth
              />
            </Grid>
          </Grid>
        </Grid>

        <Grid
          container
          justifyContent="flex-end"
          alignItems="center"
          spacing={2}
          sx={{ mt: 4 }}
        >
          {/* {FormId > 0 && ( */}
          <Grid item>
            <Button
              variant="contained"
              onClick={convertToProgressNote}
              sx={{
                minWidth: 220,
                height: 42,
                backgroundColor: "#4CAF50",
                color: "#fff",
                borderRadius: "8px",
                textTransform: "none",
                fontWeight: 600,
                boxShadow: "none",
                "&:hover": {
                  backgroundColor: "#43A047",
                  boxShadow: "none",
                },
              }}
            >
              Convert to Progress Note
            </Button>
          </Grid>
          {/* )} */}

          <Grid item>
            <Button
              type="submit"
              variant="contained"
              onClick={handleSubmit}
              sx={{
                minWidth: 120,
                height: 42,
                backgroundColor: "#A574FD",
                color: "#fff",
                borderRadius: "8px",
                textTransform: "none",
                fontWeight: 600,
                boxShadow: "none",
                "&:hover": {
                  backgroundColor: "#8A5CE6",
                  boxShadow: "none",
                },
              }}
            >
              Save
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default ConsentForm;
